<template>
	<div>
		<ul class="test" v-if="visible" :style="'left:'+style.left+'px;top:'+style.top+'px'" @contextmenu="stopDefault">
			<li v-for="(item,index) in listData" :key="index" @click="clickRow(item);">
				<span>{{item.label}}</span>
				<i :class="item.icon" v-if="item.icon"></i>
			</li>
		</ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
				visible: false,
				style: {
					left: 0,
					top: 0
				},
				listData: []
            }
        },
        methods: {	
			open(event, options) {
				let { pageX, pageY } = event || {};
				this.style = {
					left: pageX,
					top: pageY
				};	
				this.listData = options;
				this.visible = true;
			},	
			//关闭弹窗
			close() {
				this.visible = false;
			},
			//取消事件
			stopDefault(e) {
				e.preventDefault();
				e.stopPropagation();
			},	
			contains(parent, node) {
				if (document.documentElement.contains) {
					return parent !== node && parent.contains(node);
				} else {
					while (node && (node = node.parentNode)) if (node === parent) return true;
					return false;
				}
			},
			//确认选项点击			
			clickRow(e) {			
				if (e.callback) {
					return e.callback(e, () => {
						this.close();
					});
				}
			}			
        },
		mounted() {
			document.body.addEventListener("mousedown", (e) => {
				if (!this.contains(this.$el, e.target) && this.$el != e.target) {
					this.close();
				}
			});
			window.addEventListener("resize", this.close);
		},
		
			render() {
				const { default: slot } = this.$scopedSlots;
				const { left, top } = this.style;
		
				const deep = (list, pIndex, level) => {
					return (
						<div class={["cl-context-menu-box", level > 1 && "is-append"]}>
							{list
								.filter((e) => !e.hidden)
								.map((e, i) => {
									e._index = `${pIndex}-${i}`;
		
									return (
										<div
											class={{
												"is-active": this.index.includes(e._index),
												"is-ellipsis": e.ellipsis,
												"is-disabled": e.disabled
											}}>
											{/* 前缀图标 */}
											{e["prefix-icon"] && <i class={e["prefix-icon"]}></i>}
		
											{/* 标题 */}
											<span
												on-click={() => {
													this.clickRow(e);
												}}>
												{e.label}
											</span>
		
											{/* 后缀图标 */}
											{e["suffix-icon"] && <i class={e["suffix-icon"]}></i>}
		
											{/* 子集 */}
											{e.children &&
												e.showChildren &&
												deep(e.children, e._index, level + 1)}
										</div>
									);
								})}
						</div>
					);
				};
		
				return (
					this.visible && (
						<div
							class="cl-context-menu"
							style={{ left: left + "px", top: top + "px" }}
							oncontextmenu={this.stopDefault}>
							{slot ? slot() : deep(this.list, 0, 1)}
						</div>
					)
				);
			}
    }
</script>
<style scoped lang="scss">
	.test{
		width: 150px;
		min-height: 30px;
		background: #fff;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100000;
		box-shadow: 0 2px 12px #0000001a;
		border-radius: 3px;
		padding: 5px 0;
		li{
			display: flex;
			align-items: center;
			height: 35px;
			line-height: 35px;
			font-size: 13px;
			cursor: pointer;
			padding: 0 15px;
			color: #666;
			position: relative;
			&:hover{
				background: rgb(247,247,247);
			}
			span{
				flex: 1;
			}
			i{
				margin-left: 5px;
			}
		}
	}
</style>
